import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import moment from "moment";
import {
  apiError,
  getEnquirys,
  enquiryListSuccessful,
  isModelVisible,
  getEnquiryByIDSuccessful
} from "./enquirySlice";

// AUTH related methods
import {
  postAdd,
  getParamsList,
  postEdit,
  postDelete,
  getList
} from "../../../helpers/Helper";
import { Modal } from "antd";
import {
  RiCheckboxCircleLine,
  RiAlertLine,
  RiInformationLine,
} from "react-icons/ri";
import enquiryData from "./enquiryData.json"

function* EnquirysGet({ payload }) {
  var data = payload;
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] != "" && k != null && k != "no_of_pages") {
          if(k == 'start_date' ){
            params[k] = moment(data[k]).format("YYYY-MM-DD")
          }else if( k == 'end_date'){
            params[k] = moment(data[k]).add(1, "days").format("YYYY-MM-DD")
          }else{
            params[k] = data[k];
          }
        }
      }
    }
  }
  try {
    // const response = yield call(getParamsList, "/purchase/enquiry/list/", params);
    const EnquiryData = enquiryData
    yield put(enquiryListSuccessful( EnquiryData ));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* AddEnquiry({ payload }) {
  try {
    if (payload.id == 0) {
      const response = yield call(postAdd, "/purchase/enquiry/create/", payload);
      if (response.status === 201) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Enquiry Added Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getEnquirys({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to added Enquiry. Please try again!
              </p>
            </div>
          ),
        });
      }
    } else {
      const response = yield call(
        postEdit,
        "/purchase/enquiry/" + payload.id,
        payload
      );
      if (response.status === 200) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Enquiry Edited Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getEnquirys({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to edit Enquiry. Please try again!
              </p>
            </div>
          ),
        });
      }
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

function* DeleteEnquiry({ payload }) {
  var dealerID = payload;
  try {
    const response = yield call(postDelete, "/purchase/enquiry/" + dealerID);

    if (response.status === 204) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Your Enquiry has been deleted!
            </p>
          </div>
        ),
      });
      yield put(getEnquirys({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Your Enquiry has been not deleted!
            </p>
          </div>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });

    yield put(apiError(error));
  }
}


function* EnquiryByID({ payload }) {
  try {
    const response = yield call(
      getParamsList,
      "/purchase/enquiry/" + payload.row.id, {});
    yield put(getEnquiryByIDSuccessful({response, type: payload.type}));
  } catch (error) {
    yield put(apiError(error));
  }
}

export function* watchGetEnquirys() {
  yield takeEvery("enquiry/getEnquirys", EnquirysGet);
}
export function* watchEnquiryAdd() {
  yield takeEvery("enquiry/enquiryAdd", AddEnquiry);
}

export function* watchEnquiryDelete() {
  yield takeEvery("enquiry/enquiryDelete", DeleteEnquiry);
}

export function* watchGetEnquiryByID() {
  yield takeEvery("enquiry/getEnquiryByID", EnquiryByID);
}

function* EnquirySaga() {
  yield all([
    fork(watchGetEnquirys),
    fork(watchEnquiryAdd),
    fork(watchEnquiryDelete),
    fork(watchGetEnquiryByID),
  ]);
}

export default EnquirySaga;
